import { useSelector } from 'react-redux';
import { AppPermissions } from '../api';
import { State } from '../store';

export const useHasPermission = (permission?: AppPermissions) => {
  const authState = useSelector((state: State) => state.authUser);

  if (!permission) {
    return true;
  }
  return authState.apiPermissions?.[permission];
};
